import React from "react";
import SuccessMessage from "../../../components/SuccessMessage/SuccessMessage";

export default function PasswordRenewSuccess() {
  return (
    <SuccessMessage title="Neues Passwort" buttonText="Zum Login">
      <p>
        <strong>Aktion erfolgreich</strong>
      </p>
      <p>Du hast dein Passwort erfolgreich geändert.</p>
    </SuccessMessage>
  );
}
